import type { ACTION } from '@talos/kyoko';

/**
 * A single permission, or a list where any one permission is sufficient.
 */
export type ShowcaseRequiredPermission = ACTION | ACTION[];

export function isRequiredPermissionSatisfied(
  isAuthorized: (permission: ACTION) => boolean,
  requiredPermission?: ShowcaseRequiredPermission
): boolean {
  if (requiredPermission == null) {
    return true;
  }

  const permissions = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
  return permissions.some(permission => isAuthorized(permission));
}
